import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { TopHeaderService } from './top-header.service';

@Component({
  selector: 'top-header-component',
  templateUrl: './top-header.component.html',
  styleUrls: ['./top-header.component.scss'],
  imports: [DatePipe],
})
export class TopHeaderComponent implements OnInit {
  router = inject(Router);
  private ref = inject(ChangeDetectorRef);
  topHeaderService = inject(TopHeaderService);

  public show = false;
  public page: string;
  public userName: string;
  public lastUpdatedDate: string;

  ngOnInit(): void {
    this.router.events.subscribe(() => {
      const currentUrl = this.router.url;
      if (currentUrl.includes('schedule/staff')) {
        this.page = 'Staff';
        this.show = true;
      } else if (currentUrl.includes('schedule/patient')) {
        this.page = 'Patient';
        this.show = true;
      } else {
        this.show = false;
      }
    });

    this.topHeaderService.lastUpdatedInfo.asObservable().subscribe({
      next: (lastUpdatedInfo) => {
        this.userName = lastUpdatedInfo.userName;
        this.lastUpdatedDate = lastUpdatedInfo.lastUpdatedDate;
      },
    });
  }

  goToMySchedule(): void {
    this.router.navigate(['/staff-schedule/my-schedule']);
  }
}
